import { useEffect, useState } from "react";
import toast from "../../utils/toast";
import { postsApi } from "../../services";
import RankEditor from "../rank/RankEditor";
import AccCredHistory from "./AccCredHistory";
import "./accEditModal.css";

// Sửa thông tin acc (mã acc/mô tả/giá/rank-uy tín/tài khoản đăng nhập) ngay tại
// Sổ thuê acc, thay vì phải điều hướng sang trang chi tiết /post/:id.
export default function AccEditModal({ postId, username, onClose, onSaved }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [thumb, setThumb] = useState("");
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [price, setPrice] = useState("");
  const [priceValue, setPriceValue] = useState(0);
  const [accUsername, setAccUsername] = useState("");
  const [accPassword, setAccPassword] = useState("");
  const [rankInfo, setRankInfo] = useState({ rank: null, reputation: null });

  useEffect(() => {
    let alive = true;
    setLoading(true);
    Promise.all([postsApi.getPostById(postId), postsApi.getCredentials(postId)])
      .then(([post, creds]) => {
        if (!alive) return;
        setThumb(post?.thumb || "");
        setTitle(post?.title || "");
        setDesc(post?.desc || "");
        setPrice(post?.price || "");
        setPriceValue(post?.priceValue || 0);
        setAccUsername(creds?.accUsername || "");
        setAccPassword(creds?.accPassword || "");
        setRankInfo({
          rank: post?.rank?.tier ? post.rank : null,
          reputation: post?.reputation ?? null,
        });
        setLoading(false);
      })
      .catch(() => {
        toast.error("Không tải được thông tin acc");
        onClose();
      });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId]);

  // Đưa lại user/pass của một mốc cũ vào form (vẫn phải bấm Lưu để áp dụng)
  const restoreCred = (item) => {
    setAccUsername(item.prevUsername || "");
    setAccPassword(item.prevPassword || "");
    toast.info("Đã điền lại user/pass cũ — bấm Lưu thay đổi để áp dụng");
  };

  const handleSave = async () => {
    if (!title.trim()) return toast.error("Nhập mã acc");
    const updateData = {
      username,
      title: title.trim(),
      desc,
      price,
      priceValue: Number(priceValue) || 0,
      accUsername: accUsername.trim(),
      accPassword,
    };
    if (thumb === "lienquan") {
      updateData.rank = rankInfo.rank;
      updateData.reputation = rankInfo.reputation;
    }
    setSaving(true);
    try {
      await postsApi.updatePost(postId, updateData);
      toast.success("Đã cập nhật thông tin acc");
      onSaved();
    } catch {
      toast.error("Cập nhật thất bại");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="acc-modal-backdrop" onClick={onClose}>
      <div className="acc-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="acc-modal-header">
          <h3>Sửa thông tin acc{title ? ` — ${title}` : ""}</h3>
          <button className="acc-modal-close" title="Đóng" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        {loading ? (
          <div className="acc-modal-loading">Đang tải...</div>
        ) : (
          <>
            <div className="acc-modal-body">
              <label className="acc-modal-field">
                <span>Mã acc</span>
                <input
                  className="acc-modal-input"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="VD: LQ650"
                />
              </label>

              <label className="acc-modal-field">
                <span>Acc vip</span>
                <textarea
                  className="acc-modal-input acc-modal-textarea"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  rows={3}
                />
              </label>

              <div className="acc-modal-row">
                <label className="acc-modal-field">
                  <span>Giá thuê</span>
                  <input
                    className="acc-modal-input"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    placeholder="VD: 3h/30.000"
                  />
                </label>
                <label className="acc-modal-field">
                  <span>Giá tính tiền (₫/h)</span>
                  <input
                    type="number"
                    className="acc-modal-input"
                    value={priceValue}
                    min="0"
                    step="1000"
                    onChange={(e) => setPriceValue(e.target.value)}
                  />
                </label>
              </div>

              <div className="acc-modal-row">
                <label className="acc-modal-field">
                  <span>Tài khoản đăng nhập</span>
                  <input
                    className="acc-modal-input"
                    value={accUsername}
                    onChange={(e) => setAccUsername(e.target.value)}
                    placeholder="username acc game"
                    autoComplete="off"
                  />
                </label>
                <label className="acc-modal-field">
                  <span>Mật khẩu</span>
                  <input
                    className="acc-modal-input"
                    value={accPassword}
                    onChange={(e) => setAccPassword(e.target.value)}
                    placeholder="password acc game"
                    autoComplete="off"
                  />
                </label>
              </div>

              <AccCredHistory postId={postId} collapsible onRestore={restoreCred} />

              {thumb === "lienquan" && (
                <div className="acc-modal-field">
                  <span>Rank &amp; uy tín</span>
                  <RankEditor value={rankInfo} onChange={setRankInfo} />
                </div>
              )}
            </div>

            <div className="acc-modal-actions">
              <button className="btn btn-secondary" onClick={onClose}>Hủy</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                {saving ? <i className="fas fa-spinner fa-spin"></i> : "Lưu thay đổi"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
